import { Modal, ModalHeader, ModalBody, ModalContent } from "@heroui/react";
import FireSecurityBuildingInfoComponent from "./fireSecurityBuildingInfoComponent";
import { useEffect } from "react";

const FireSecurityBuildingCheckModal = ({ isOpen, onClose, building }: any) => {

    useEffect(() => { console.log(building) }, [])

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="5xl"
            shouldBlockScroll={true}
            isDismissable={true}
            scrollBehavior="inside"
            backdrop="blur"
            className="p-8"
        >
            <ModalContent className="flex flex-col gap-4 font-normal text-neutral-primary">
                <ModalHeader className="flex flex-row items-center justify-between p-0 font-normal">
                    <p>{building.id} - Brandveiligheid</p>
                </ModalHeader>
                <ModalBody className="px-0">
                    <FireSecurityBuildingInfoComponent
                        fireSecurityBuildingInfo={{ ...building?.fireSecurityBuildingInfo, buildingId: building.id }}
                        handleCloseParent={onClose}
                    />
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default FireSecurityBuildingCheckModal;
